import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Breadcrumb, Row, Col } from 'react-bootstrap';

import { getAllAvailableDockers } from './../../../../actions/closeLoop/apmDashboard/instancesActions';

import StreamingContainer from './StreamingContainer';
import Flash from './../../../../utilityComponents/Message';
import Loader from './../../../../utilityComponents/Loader';
import PropTypes from "prop-types";


function InstanceHealth(props) {
    const [regionName, setRegionName] = useState(undefined);

    useEffect(() => {
        const { region, instanceId } = props.match.params;
        setRegionName(region);
        if(props.selectedInstance === undefined) {
            props.fetchDockers(instanceId);
        } else {
            props.fetchDockers(props.selectedInstance);
        }
    }, [])

    console.log(props);

    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item href='/navigate_new'>Home</Breadcrumb.Item>
                <Breadcrumb.Item href='/close_loop/real_time/apm/dashboard'>Regions</Breadcrumb.Item>
                <Breadcrumb.Item href={`/close_loop/running/bench-instances/${regionName}`}>Running Instances {regionName}</Breadcrumb.Item>
                <Breadcrumb.Item active>Instance Health</Breadcrumb.Item>
            </Breadcrumb>
            <Container fluid>
                { props.loading ? <Loader /> : props.error ? <Flash>{ props.error }</Flash> : props.dockers.length === 0 ? (
                    <Flash variant='info'>No Dockers found running in this instance!</Flash>
                ) : (props.dockers && props.dockers.length >= 1) ?
                    props.dockers.map((item, index) => {
                        console.log("index", index)
                        return (
                            <Row key={item['id']}>
                                { item['values'].map((subItem, subIndex) => {
                                    return (
                                        <Col md={6} xl={6} lg={6} key={subIndex}>
                                            <StreamingContainer resource={subItem} key={subIndex}/>
                                        </Col>
                                    )
                                }) }
                            </Row>
                        )
                    }) : <Flash>No dockers are running for this instance</Flash>
                 }
            </Container>
        </>
    )
}

const mapStateToProps = (state) => ({
    selectedInstance: state.instances.selectedInstance,
    loading: state.availableDockers.loading,
    error: state.availableDockers.error,
    dockers: state.availableDockers.info,
});

const mapDispatchToProps = (dispatch) => ({
    fetchDockers: (payload) => dispatch(getAllAvailableDockers(payload)),
});

InstanceHealth.propTypes = {
    match: PropTypes.array,
    selectedInstance: PropTypes.string,
    fetchDockers: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string,
    dockers: PropTypes.array,
};
InstanceHealth.defaultProps = {
    match: [],
    selectedInstance: '',
    loading: false,
    error: '',
    dockers: []
};


export default connect(mapStateToProps, mapDispatchToProps)(InstanceHealth);

